<template>
  <!-- 设备仪器柜绑定 -->
  <div class="container_eb" v-loading.fullscreen.lock='loading' element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
    <div class="main_eb">
      <div class="btns_wh">
        <div class="b_header">
          <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/warehouse' }">库房管理</el-breadcrumb-item>
              <el-breadcrumb-item>设备绑定</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
      </div>
      <div>
        <div class="listall_eb">
          <div class="list_eb">
            <div class="list_h">
              <span>现有仪器列表</span>
              <div class="my-buttom" :class="[ DeviceType ==1 ? 'select-buttom' : '']" @click="dType(1)">
                仪 器
              </div>
              <div class="my-buttom" :class="[DeviceType == 2 ? 'select-buttom' : '']" @click="dType(2)">
                仪器组合
              </div>
              <el-input placeholder="请输入仪器名称进行检查" v-model="input1">
                <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
              </el-input>
            </div>
            <!-- 现有仪器列表 -->
            <transition name="fade" mode="out-in">
              <div class="li_cocntent bar" v-infinite-scroll="loadMore" v-infinite-scroll-disabled="loading" v-infinite-scroll-distance="20">
                <ul class="list-content" v-for="(now, nowIndex) in personList" :key="nowIndex">
                  <li class="list_li" :title="now.instrumentName">
                    <img :src="now.photoLink" alt />
                    <p>{{ now.instrumentName }}</p>
                    <p>{{ now.serialNumber }}</p>
                  </li>
                  <input type="radio" v-model="checkedValue" @change="cval(nowIndex)" :value="now.id" />
                </ul>
              </div>
            </transition>
          </div>
          <div class="Transfer">
            <div>
              <el-button class="arrow_r" @click="binding">仪器绑定</el-button>
            </div>
            <div>
              <el-button class="arrow_l" @click="unbind">仪器解绑</el-button>
            </div>
          </div>
          <!-- 右侧柜子 -->
          <div class="gz">
            <div class='gz-info'>
              <div class='gzNumber'>
                <div class="icon-bg"><i class="iconfont icon-iconset0499"></i></div>
                <span class="gz-title"> {{gzName}}</span>
              </div>
              <div class='gzNumber'>
                <div class="icon-bg"><i class="iconfont icon-guizi"></i></div>
                <span class="gz-title">{{BoxList | Hasused}}</span>
              </div>
            </div>
            <div :class="['gz_content',BoxList.length > 10 ? 'bar gz_scroll' : '']" @mousemove="setScroolFun">
              <div :class="['gzall', 'grid_'+Math.ceil(BoxList.length/2)]">
                <template v-for="(item, index) in BoxList">
                  <div :key="index">
                    <ul>
                      <template v-if="item.states != 3">
                        <li :class="['gzli_have', selectId == item.id ? 'gz_select' : '']" @click="select(item.id, item.instrument.id)" :title="item.instrument.instrumentName" v-if="item.instrument">
                          <div class="gz_bg">
                            <div class="gz_bg_title">
                              <span>{{ item.boxIndex }}</span>
                              <el-badge v-if="item.states == 2" is-dot class="item" type="danger"></el-badge>
                              <el-badge v-else-if="item.states == 1" is-dot class="item" type="success"></el-badge>
                              <el-badge v-else is-dot class="item" type="danger"></el-badge>
                            </div>
                            <div class="gz_bg_contet">
                              <img :src="item.instrument.photoLink" alt />
                              <div>
                                <p class="gz_infoname"> {{ item.instrument.instrumentName }} </p>
                                <p class="gz_infonum">
                                  {{ item.instrument.serialNumber }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li v-else :class="[ 'gzli_have','gzli_not', selectId == item.id ? 'gz_select' : '']" :key="index" @click="select(item.id)">
                          <div>
                            <p style="color: #00a9ff; font-size: 24px">
                              {{ item.boxIndex }}
                            </p>
                            <p style="color: #999">
                              <i class="el-icon-remove"></i>未绑定仪器
                            </p>
                          </div>
                        </li>
                      </template>
                    </ul>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBoxInfo, boxBind, boxUnbind } from "@/api/warehouse";
import { getFreeInsList2, getFreeInsList3 } from "@/api/depotApi.js";
import Vue from "vue";
import scroll from "@/util/scroll";
Vue.use(scroll);
export default {
  inject: ["reload"],
  data() {
    return {
      selectId: "", //当前选中格口id
      BoxList: [], //柜子格口信息
      id: "", //当前柜子id
      gzName: "", //当前柜子名称
      yqId: "", //当前选中仪器id
      DeviceType: 1, //设备类型
      documentObj: null, //滚动事件
      show: "", //是否显示选中效果
      input1: "", //搜索框内容
      checkedValue: "", //选中的checked项
      personList: [], //仪器列表
      deptId: "", //单位id
      DepotId: "", //仓库id
      btnData: [], //仓库按钮
      PageIndex: 1, //页码
      PageSize: 12, //条数
      total: 0, //总条数
      loading: false,
      cVal: "", //当前选中仪器的下标
    };
  },
  created() {
    this.selectId = sessionStorage.getItem("boxId");
    this.deptId = this.$store.state.user.userInfo.deptId;
    this.btnData = this.$store.state.user.depotList;
    if (this.btnData.length != 0) {
      this.DepotId = sessionStorage.getItem("depotId");
    }
    this.id = this.$route.query.id;
    this.gzName = this.$route.query.name;
    this.acquire();
    this.getNowInfo();
  },
  mounted() {},
  methods: {
    //获取仪器设备列表
    acquire() {
      let params = {
        states: 0,
        status: 0,
        deviceType: this.DeviceType,
        depotId: Number(this.DepotId),
        deptId: Number(this.deptId),
        pageIndex: this.PageIndex,
        pageSize: this.PageSize,
      };
      this.loading = true;
      if (this.DeviceType == 1) {
        getFreeInsList2(params)
          .then((res) => {
            if (res.code == 200) {
              this.personList = this.personList.concat(res.data.records);
              this.total = res.data.total;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (this.DeviceType == 2) {
        getFreeInsList3(params)
          .then((res) => {
            if (res.code == 200) {
              this.personList = this.personList.concat(res.data.records);
              this.total = res.data.total;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    cval(val) {
      this.cVal = val;
    },
    //获取当前点击仪器柜信息
    getNowInfo() {
      getBoxInfo(this.id)
        .then((res) => {
          if (res.code == "200") {
            this.BoxList = res.data;
          }
        })
        .catch((err) => {});
    },
    dType(val) {
      this.DeviceType = val;
      this.PageIndex = 1;
      this.search();
    },
    //搜素
    search() {
      let params = {
        searchInfo: this.input1,
        states: 0,
        status: 0,
        deviceType: this.DeviceType,
        depotId: Number(this.DepotId),
        deptId: Number(this.deptId),
        pageIndex: 1,
        pageSize: this.PageSize,
      };
      this.loading = true;
      if (this.DeviceType == 1) {
        getFreeInsList2(params)
          .then((res) => {
            if (res.code == 200) {
              this.personList = res.data.records;
              this.total = res.data.total;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (this.DeviceType == 2) {
        getFreeInsList3(params)
          .then((res) => {
            if (res.code == 200) {
              this.personList = res.data.records;
              this.total = res.data.total;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
      this.input1 = "";
    },
    //绑定
    binding() {
      if (!this.checkedValue) {
        return this.$message.error("请选择仪器后进行绑定");
      }
      if (!this.selectId) {
        return this.$message.error("请选择格口");
      }
      let params = {
        instrumentId: this.checkedValue,
        boxid: this.selectId,
      };
      boxBind(params).then((res) => {
        if (res.code == 200) {
          this.personList.splice(this.cVal, 1);
          this.selectId = "";
          this.getNowInfo();
          this.$message.success(res.msg || "绑定成功！");
        } else {
          this.$message.error(res.msg || "绑定失败！");
        }
      });
    },
    //解绑
    unbind() {
      if (!this.yqId) {
        return this.$message("请点击需要解绑的格口以获取解绑仪器id");
      }
      boxUnbind(this.yqId).then((res) => {
        if (res.code == "200") {
          (this.checkedValue = ""), this.reload();
          this.$message.success(res.msg || "解绑成功！");
        } else {
          this.$message.error("解绑失败！" + res.msg);
        }
      });
    },
    // 选中柜子
    select(boxId, yqId) {
      this.selectId = boxId;
      this.yqId = yqId;
    },

    // 加载更多
    loadMore() {
      let sum = Math.ceil(this.total / this.PageSize);
      if (this.PageIndex < sum) {
        this.PageIndex++;
        this.acquire();
      } else if (this.PageIndex == sum) {
        if (this.personList.length > 8) {
          this.$message(`没有更多啦！`);
        }
      }
    },

    setScroolFun() {
      this.documentObj = null;
      this.documentObj = document.querySelector(".gzall");
      if (this.documentObj) {
        this.documentObj.style = "padding-left: 15px";
      }
    },
  },
  filters: {
    Hasused: function (val) {
      let sum = val.length;
      let n = 0;
      val.forEach((item) => {
        if (item.states == 1) {
          n++;
        }
      });
      return `${n}/${sum}`;
    },
  },
};
</script>

<style  lang='less' scoped>
.my-buttom {
  width: 90px;
}
ul {
  list-style: none;
}
.router-link-active,
a {
  text-decoration: none;
}
// 状态样式
/deep/.el-badge__content--success {
  background-color: #0f0;
  box-shadow: 0 0 5px#0f0;
  border: none;
}
/deep/.el-badge__content--danger {
  background-color: red;
  box-shadow: 0 0 5px red;
  border: none;
}
//按钮样式
.el-button {
  background: url(~@/assets/images/btn.png) no-repeat center;
  background-size: 100% 100%;
  border: none;
  color: #74c8fe;
}

.container_eb {
  .main_eb {
    margin: 0 auto;
    color: #74c8fe;
    .btns_wh {
      width: 1500px;
      padding: 0 10px;
      box-sizing: border-box;
      margin: 0 auto;
      .b_header {
        //面包屑导航
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        /deep/.el-breadcrumb__inner {
          color: #74c8fe;
        }
        /deep/ .el-breadcrumb__separator {
          color: #74c8fe;
        }
      }
    }

    .listall_eb {
      width: 1570px;
      margin: 0 auto;
      margin-top: 15px;
      display: grid;
      justify-items: center;
      grid-template-columns: 900px 200px 447px;
      grid-template-rows: 766px;

      .list_eb {
        width: 814px;
        background: url(~@/assets/images/kzq.png) no-repeat center;
        background-size: 100% 100%;
        .list_h {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 25px 40px;
          .el-input {
            width: 400px;
            border-radius: 16px;
          }
          .el-input__icon:hover {
            cursor: pointer;
          }
          /deep/ .el-input__inner {
            background: url(~@/assets/images/yjjx2.png) no-repeat center;
            background-size: 100% 100%;
            border: none;
            color: #74c8fe;
          }
        }
      }
      //现有仪器列表样式
      .li_cocntent {
        height: 654px;
        margin: 0 20px;
        overflow-y: auto;
        display: grid;
        grid-template-rows: repeat(3, 33.33%);
        grid-template-columns: repeat(auto-fill, 25%);
        grid-row-gap: 8px;
        .list-content {
          .list_li {
            width: 150px;
            height: 180px;
            margin-bottom: 20px;
            border-radius: 10px;
            margin-left: 15px;
            background: url(~@/assets/images/kzq.png) no-repeat center;
            background-size: 100% 100%;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            padding: 20px;
            box-sizing: border-box;
            p {
              width: 100px;
              height: 24px;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            img {
              width: 80px;
              height: 58px;
              margin-bottom: 20px;
            }
            /deep/.el-checkbox {
              margin-top: 15px;
            }
            /deep/.el-checkbox__inner {
              background: #1e5fb3;
              width: 35px;
              height: 35px;
              border: none;
              border-radius: 6px;
            }
            /deep/.el-checkbox__inner::after {
              border: 5px solid #74b7ff;
              -webkit-box-sizing: content-box;
              box-sizing: content-box;
              content: "";
              border-left: 0;
              border-top: 0;
              height: 12px;
              left: 13px;
              position: absolute;
              top: 7px;
              width: 5px;
            }
            .el-checkbox:last-of-type {
              margin-left: 150px;
            }
          }
        }
      }
      .Transfer {
        width: 200px;
        //  height: 814px;
        padding: 250px 0px;
        text-align: center;
        margin-right: 40px;
        .arrow_r {
          background-image: url(~@/assets/images/equipment/ar.png);
          background-size: 100% 100%;
          width: 130px;
          height: 71px;
          margin-bottom: 50px;
        }
        .arrow_l {
          background-image: url(~@/assets/images/equipment/al.png);
          background-size: 100% 100%;
          width: 130px;
          height: 71px;
        }
        div {
          margin: 40px 0;
          padding: 0px;
        }
      }
      //右侧柜子样式
      .gz {
        width: 447px;
        height: 740px;
        background: url(~@/assets/images/gz.png);
        background-size: 100% 100%;
        // margin-top: 30px;
        .gz-info {
          position: absolute;
          top: 123px;
          // padding: 0 80px;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: repeat(2, 49%);
          width: 447px;
          font-weight: bold;
          line-height: 10px;
          .gzNumber {
            margin: 0 auto;
            height: 30px;
            line-height: 30px;
            font-size: 18px;
            color: #0153e9;
            border-radius: 6px;
            display: flex;
            align-items: center;
            font-weight: normal;
            .icon-bg {
              width: 30px;
              text-align: center;
              position: relative;
              left: -2px;
              line-height: 28px;
              i {
                font-size: 20px;
              }
            }
            .gz-title {
              margin: 0 auto;
              font-weight: 500;
            }
          }
        }
        .gz_content {
          margin-top: 50px;
          margin-right: 5px;
          overflow-x: hidden;
          overflow-y: auto;
        }
        .grid_3 {
          grid-template-rows: repeat(3, 20%);
        }
        .grid_4 {
          grid-template-rows: repeat(4, 20%);
        }
        .grid_5 {
          grid-template-rows: repeat(5, 20%);
        }
        .grid_6 {
          grid-template-rows: repeat(6, 20%);
        }
        .grid_7 {
          grid-template-rows: repeat(7, 20%);
        }
        .grid_8 {
          grid-template-rows: repeat(8, 20%);
        }
        .grid_9 {
          grid-template-rows: repeat(9, 20%);
        }
        .grid_10 {
          grid-template-rows: repeat(10, 20%);
        }
        .gzall {
          padding-left: 15px;
          width: 428px;
          height: 687px;
          display: grid;
          justify-items: center;
          grid-template-columns: repeat(2, 46%);
          // grid-row-gap: 5px;
          grid-auto-flow: column;
          grid-column-gap: 15px;
          .gz_select {
            box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
            border-radius: 20px;
          }
          //柜子已绑定样式(柜门区别)
          .gzli_have {
            width: 194px;
            height: 125px;
            background: url(~@/assets/images/gm.png);
            background-size: 100% 100%;
            float: left;
            font-size: 12px;
            font-weight: normal;
            color: #00a9ff;
            display: grid;
            align-items: center;
            justify-content: center;
            text-align: center;
            cursor: pointer;
            .gz_bg {
              width: 138px;
              height: 82px;
              background: #c4e1f9;
              box-sizing: border-box;
              font-size: 14px;
              color: #5eabd7;
              z-index: 99;
              .gz_bg_title {
                display: flex;
                justify-content: space-between;
                padding: 8px 8px 3px 8px;
              }
              .gz_bg_contet {
                display: flex;
                align-items: center;
                height: 40px;
                //仪器图片
                img {
                  width: 40px;
                  height: 25x;
                  margin-right: 8px;
                  margin-left: 5px;
                }
                .gz_infoname,
                .gz_infonum {
                  width: 90px;
                  height: 20px;
                  font-size: 12px;
                  text-align: start;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }
          }

          .gz_select {
            box-shadow: 0 0 20px rgba(255, 255, 255, 0.8);
            border-radius: 20px;
          }
          //未绑定样式
          .gzli_not {
            display: grid;
            align-items: center;
            justify-items: center;
            text-align: center;
            .gzstate {
              display: grid;
              align-items: center;
              justify-items: center;
              font-size: 14px;
              color: #74c8fe;
            }
            .gzstate > p:first-child {
              font-size: 26px;
            }
          }
        }
      }
    }
  }
}

.bar::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}

input[type="radio"] {
  cursor: pointer;
  position: relative;
  width: 5px;
  height: 5px;
  font-size: 14px;
  left: 170px;
  bottom: 40px;
  border: 0;
  -webkit-appearance: none;
  border-radius: 6px;
}

input[type="radio"]::after {
  position: absolute;
  top: -10px;
  left: -20px;
  background-color: #1e5fb3;
  color: #74b7ff;
  width: 30px;
  height: 30px;
  display: inline-block;
  visibility: visible;
  text-align: center;
  content: " ";
  border: 0;
  border-radius: 6px;
  -webkit-appearance: none;
}

input[type="radio"]:checked::after {
  background: #1e5fb3;
  content: "✓";
  font-size: 20px;
  font-weight: bolder;
  -webkit-appearance: none;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/equipmentbind/index.vue